import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';

import axios from "../../../../../axios-defaults";
import Spinner from "../../../../UI/Spinner";

import './css/Form.css';
//import RealexHpp from "../../../../../rxp-js";

class Add extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            url: null,
        }
        this.saveBankReference = this.saveBankReference.bind(this);
    }

    saveBankReference = (message) => {
        if(typeof message?.data?.Step !== 'undefined' && message.data.Step === 'LINK') {
            console.log('Link: ');
            console.log(message);

            axios.post(`/banks`,{ data: message.data })
                .then(response => {
                    console.log('Saved!');
                    this.props.refreshBanksList();
                    this.props.handleNewBankAdded('success', this.props.t('saved_banks.messages.add_success'))
                })
                .catch(error => {
                    this.props.handleNewBankAdded('error', this.props.t('saved_banks.messages.add_error'))
                });
        }
    }

    async componentDidMount() {

        await axios.get(`/vopay/return-iq11-generated-embed-url`)
            .then(response => {
                this.setState({loading:false});

                //console.log('response.data.url: ');
                //console.log(response.data.url);
                //this.setState({url:response.data.url});
                $('#vopay-pay-container').show();
                this.setState({url:response.data.url});
                window.addEventListener('message', this.saveBankReference, false);
                
                setTimeout(function(){
                    //$('#vopay-pay-container').show();
                    //this.setState({url:response.data.url});
                }.bind(this),1000)

            }).catch(error => {
            console.log('[Profile/SavedPaymentMethods/Banks/Forms/Add.js] : Ajax error in componentDidMount()',error.message);
        });
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.saveBankReference, false);
    }

    render() {
        const {loading,url} = this.state;

        return (
            <div className="container container--larger">
                {loading ?
                    <Spinner />:null}
                    <div id={'vopay-pay-container'}>
                        <iframe  src={url}>
                        </iframe>
                    </div>
            </div>
        );
    }
}

export default withTranslation()(Add);
